import React, { useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import {getAsset} from "../../actions/assetAction";
import { getAssetAttributes } from "../../actions/assetAttributesActions";
import {getAssetchart,getAttributescurrency,getAttributelegalStructure,getSecurityType,getAssetInvestmentType,getAssetFilingStatus,getInvestorFrequency,getAssetReportingFrequency,getExposuresReportingFrequency,getInvestInOtherFunds,getEstimateFrequency} from "../../actions/assetAttributesActions";
import { useNavigate } from "react-router";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { useParams, useLocation } from "react-router-dom";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { SBADropDown } from "../../UiComponents/SBADropDown";
import { UrlPath } from "../../../config/routeConfig";
import moment from "moment";
import { TopBar } from "../../shared/topBar/TopBar";
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import { InsertorUpdateAttributes } from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";

export const AttributesAdd = () => {
  const isEditable=useSelector(state=>state.authorizationData.isEditable);
  const [assetAttributeId,setassetAttributeId]=useState();
  const [assetFamily,setassetFamily]=useState();
  const [assetFamilyId,setassetFamilyId]=useState();
  const [chartofAccount,setchartofAccount]=useState();
  const [chartofAcconutId,setchartofAccountId]=useState();
  const[operatingCurreny,setoperatingCurrency]=useState();
  const[operatingCurrenyId,setoperatingCurrencyId]=useState();
  const[legalStructure,setlegalStructure]=useState();
  const[legalStructureId,setlegalStructureId]=useState();
  const[domicileCountry,setdomicileCountry]=useState();
  const[domicileCountryId,setdomicileCountryId]=useState();
  const[quarterlyLetter,setquartelyLetter]=useState();
  const[assetsecurityType,setassetsecurityType]=useState();
  const[assetsecurityTypeId,setassetsecurityTypeId]=useState();
  const[auditcompletiondate,setauditcompletiondate]=useState(new Date());
  const[personalCapital,setpersonalCapital]=useState();
  const[acceptmanagedAccounts,setacceptmanagedAccounts]=useState();
  const[investmanagedAccounts,setinvestmanagedAccounts]=useState();
  const[tradingCity,settradingCity]=useState();
  const[prohibitsusInvestors,setprohibitsusInvestors]=useState();
  const[filingStatus,setFilingStatus]=useState();
  const[filingStatusId,setFilingStatusId]=useState();
  const[keyMan,setkeyMan]=useState();
  const[letterstoinvestorFrequency,setletterstoinvestorFrequency]=useState();
  const[performanceestimateFrequency,setperformanceestimateFrequency]=useState();
  const[reportingFrequency,setreportingFrequency]=useState();
  const[fiscalyearEnd,setfisicalyearEnd]=useState();
  const[formDNumber,setformDNumber]=useState();
  const[vintageYear,setvintageYear]=useState();
  const[targetfundRaise,settargetfundRaise]=useState();
  const[estimatedfirstcloseAmount,setestimatedfirstcloseAmount]=useState();
  const[estimatedfirstcloseDate,setestimatedfirstcloseDate]=useState();
  const[estimatedsecondcloseAmount,setestimatedsecondcloseAmount]=useState();
  const[estimatedsecondcloseDate,setestimatedsecondcloseDate]=useState();
  const[offercoInvestment,setoffercoInvestment]=useState();
  const[singledealFund,setsingledealFund]=useState();
  const[continuationFund,setcontinuationFund]=useState();
  const[investmentType,setinvestmentType]=useState();
  const[investmentTypeId,setinvestmentTypeId]=useState();
  const[investmentPack,setinvestmentPack]=useState();
  const[assetfactSheet,setassetfactSheet]=useState();
  const[allowsidePocket,setallowsidePocket]=useState();
  const[investsinotherFunds,setinvestsinotherFunds]=useState();
    const [exposurereportFrequency, setexposurereportFrequency] = useState();
  const currentAsset = useSelector((state) => state.asset.asset); 
    const params = useParams();
    const dispatch = useDispatch();
    const history = useNavigate();
    const Level = [
        { BreadCrumb: "Asset >", Routes: `${UrlPath.Asset}` },
        { BreadCrumb: `${currentAsset.AssetName} >`, Routes: `${UrlPath.AssetDetails}${params.Asset}` },
        { BreadCrumb: "Add", Routes: `${UrlPath.AssetAttributesAdd}${params.Asset}` },
      ];
      useEffect(() => {
        dispatch(getAsset(params.Asset));
         dispatch(getAssetchart());
         dispatch(getAttributescurrency());
         dispatch(getAttributelegalStructure());
         dispatch(getSecurityType());
         dispatch(getAssetFilingStatus());
         dispatch(getInvestorFrequency());
         dispatch(getAssetReportingFrequency());
         dispatch(getExposuresReportingFrequency());
         dispatch(getEstimateFrequency());
         dispatch(getInvestInOtherFunds());
          dispatch(getAssetInvestmentType());
               
       }, []);
       const Gstate =
       useSelector((state) => {
         return state;
       }) || {};
   const Chartofaccounts =Gstate.chartofaccounts.chartofaccounts||[];
     const AttributesCurrency=Gstate.attributescurrency.attributescurrency||[];
     const LegalStructure=Gstate.attributelegalstructure.attributelegalstructure||[];
     const SecurityType=Gstate.securityType.securityType||[];
     const FilingStatus=Gstate.filingStatus.filingStatus||[];
     const InvestorLetterfrequency=Gstate.investorFrequency.investorFrequency||[];
     const PerformanceEstimatefrequency=Gstate.performanceEstimateFrequency.performanceEstimateFrequency||[];
     const Reportingfrequency=Gstate.reportingFrequency.reportingFrequency||[];
     const ExposureReportingfrequency=Gstate.exposureReportingFrequency.exposureReportingFrequency||[];
     const InvestinOtherFunds=Gstate.investInOtherFunds.investInOtherFunds||[];
    const InvestmentType = Gstate.investmentType.investmentType || [];
  
     useEffect(() => {
      setchartofAccount({ChartOfAccountsId:Chartofaccounts[0]?.ChartOfAccountsId,ChartOfAccount:Chartofaccounts[0]?.ChartOfAccount})
      setoperatingCurrency({CurrencyId:AttributesCurrency[0]?.OperatingCurrencyId,CurrencyCode:AttributesCurrency[0]?.OperatingCurrency});
      setlegalStructure({EnumValue:LegalStructure[0]?.LegalStructureId,EnumName:LegalStructure[0]?.LegalStructure});
      setassetsecurityType({EnumValue:SecurityType[0]?.AssetSecurityTypeId,EnumName:SecurityType[0]?.AssetSecurityType});
      setFilingStatus({EnumValue:FilingStatus[0]?.FilingStatusId,EnumName:FilingStatus[0]?.FilingStatus});
     setletterstoinvestorFrequency({EnumValue:InvestorLetterfrequency[0]?.InvestorLetterFrequencyId,EnumName:InvestorLetterfrequency[0]?.InvestorLetterFrequency});
   setperformanceestimateFrequency({EnumValue:PerformanceEstimatefrequency[0]?.PerformanceEstimateFrequencyId,EnumName:PerformanceEstimatefrequency[0]?.PerformanceEstimateFrequency});
    setreportingFrequency({EnumValue:Reportingfrequency[0]?.ReportingFrequencyId,EnumName:Reportingfrequency[0]?.ReportingFrequency});
   setexposurereportFrequency({EnumValue:ExposureReportingfrequency[0]?.ExposureReportFrequencyId,EnumName:ExposureReportingfrequency[0]?.ExposureReportFrequency});
     setinvestsinotherFunds({EnumValue:InvestinOtherFunds[0]?.InvestsInOtherFundsId,EnumName:InvestinOtherFunds[0]?.InvestsInOtherFunds});
     setinvestmentType({EnumValue:InvestmentType[0]?.InvestmentTypeId,EnumName:InvestmentType[0]?.InvestmentType});
    }, []);
// On Change...//
const assetfamilyChange = (event) => {
  // const result = SBATextBox(event.target.value)
  // setuniversenametrim(result);
setassetFamily(event.target.value);
};
const chartofAccountChange = (e) => {
  setchartofAccount(e.value);
  setchartofAccountId(e.value.ChartOfAccountsId);
};
const operatingcurrencyChange = (e) => {
  setoperatingCurrency(e.value);
  setoperatingCurrencyId(e.value.CurrencyId);
};

const legalstructureChange = (e) => {
  setlegalStructure(e.value);
  setlegalStructureId(e.value.CurrencyId);
};

const assetsecurityTypeChange = (e) => {
  setassetsecurityType(e.value);
  setassetsecurityTypeId(e.value.AssetSecurityTypeId);
 };
 const AuditCompletionDateChange=(selected)=>
 {
  setauditcompletiondate(new Date(moment(selected.value).format('MM/DD/YYYY')));
 }
 const InvestmentTypeChange=(e)=>
 {
setinvestmentType(e.value)
setinvestmentTypeId(e.value.EnumValue);
 }

 const SaveAttributeDetails = (event) => {
event.preventDefault();
let saveSuccess = true;
let errorMsg = [];
// Prepare the data to be sent in the POST request
const data = {
  "AssetAttributionId":0 ,
  "AssetId":params.AssetId,
  "AssetFamilyId": 0,
  "chartofAccountId": chartofAcconutId,
  "operatingcurrencyId": operatingCurrenyId,
  "legalstructureId": legalStructureId,
  "Domicilecountry": 0,
  "quarterlyLetter": quarterlyLetter,
  "AssetSecurityType": assetsecurityTypeId,
  "auditcompletiondate": auditcompletiondate,
  "InvestmentTypeId": investmentTypeId,
  "InvestmentPack": investmentPack,
  "AssetFactSheet": assetfactSheet,
  "ModifiedBy": 0
};
  if (saveSuccess) {
      sbaAxios({
          url: `${InsertorUpdateAttributes}`,
          method: 'post',
          data: data,
      })
    .then((responseData) => {
    toast.success('Attributes Saved Successfully', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    })
    setTimeout(() => {
      history(`${UrlPath.AssetDetails}${params.Asset}`,{ state: { ActiveTab: "Attributes", ActiveTabID: 2 } });
    }, 1000);
  })

    .catch((error) => {
    console.error(error);
  });
}
else {
let ErrorString = "";
errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
console.log(errorMsg);
toast.error(ErrorString, {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
  theme: "light",
})
}

};

const CanceltoDetails = () => {
    history(`${UrlPath.AssetDetails}${params.Asset}`, { state: { ActiveTab: "Attributes", ActiveTabID: 2 } })
}
  return (
    <div>
      
          <TopBar label={"Attributes Add"} />
          <BreadCrumbs Levels={Level} />
          <div id="content" class="asset-detail-screen mainContentData">
            <div class="p-4">
              <div class="d-flex align-items-center justify-content-between my-2 flex-wrap flex-lg-nowrap">
                <div class="d-flex gap-2 align-items-center">
             <h2 class="fw-medium fs-6 m-0">{currentAsset?.AssetName}</h2>
                </div>
                  </div>
                      <div className="row-md-12 d-flex gap-2">
                          {(() => {
                              switch (currentAsset.SecurityTypeId) {
                                  case 1:
                                  case 17:
                                      return (
                                          <div className="col-md-8">
                                              {
                                                  <div id="manfield" className="p-3 bg-white life-science rounded">

                                                      <div className="row">

                                                          <div className="col-md-4">

                                                              <label>Inception Date </label>
                                                              <DatePicker value={new Date()} format="MM/dd/yyyy"></DatePicker>
                                                          </div>

                                                          <div className="col-md-4">

                                                              <label>Fiscal Year End</label>
                                                              <DatePicker value={new Date()} format="MM/dd/yyyy"></DatePicker>
                                                          </div>

                                                          <div className="col-md-4">
                                                              <label style={{ display: 'flex', alignItems: 'center' }}>
                                                                  <input className="me-1"
                                                                      type="checkbox"
                                                                  />
                                                                  <span >Prohibits US Investors</span>
                                                              </label>
                                                          </div>

                                                      </div>
                                                      <div className="row" style={{ marginBottom: "20px" }}>

                                                          <div className="col-md-4">
                                                              <label>Legal Structure</label>
                                                              <SBADropDown
                                                                  value={
                                                                      legalStructure
                                                                  }
                                                                  textField={"EnumName"}
                                                                  valueField={"EnumValue"}
                                                                  data={LegalStructure}
                                                                  onChange={legalstructureChange}
                                                              ></SBADropDown>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <label>Audit Completion Date</label>
                                                              <DatePicker defaultValue={new Date()} format="MM/dd/yyyy" weekNumber={true} onChange={AuditCompletionDateChange} />
                                                          </div>

                                                          <div className="col-md-4">
                                                              <label style={{ display: 'flex', alignItems: 'center' }}>
                                                                  <input className="me-1"
                                                                      type="checkbox"
                                                                  />
                                                                  <span >Accepts Managed Accounts</span>
                                                              </label>

                                                          </div>

                                                      </div>


                                                      <div className="row" style={{ marginBottom: "20px" }}>

                                                          <div className="col-md-4">
                                                              <label>Operating Currency</label>
                                                              <SBADropDown
                                                                  value={
                                                                      operatingCurreny
                                                                  }
                                                                  textField={"CurrencyCode"}
                                                                  valueField={"CurrencyId"}
                                                                  data={AttributesCurrency}
                                                                  onChange={operatingcurrencyChange}
                                                              > </SBADropDown>
                                                          </div>

                                                          <div className="col-md-4">
                                                              <label>FormD Number</label>
                                                              <input
                                                                  className="form-control"
                                                                  type="text"
                                                              />
                                                          </div>

                                                          <div className="col-md-4">

                                                              <label>Invests In Other Funds</label>
                                                              <SBADropDown
                                                                  value={
                                                                      investsinotherFunds
                                                                  }
                                                                  textField={"EnumName"}
                                                                  valueField={"EnumValue"}
                                                                  data={InvestinOtherFunds}
                                                              ></SBADropDown>
                                                          </div>



                                                      </div>

                                                      <div className="row" style={{ marginBottom: "20px" }} >

                                                          <div className="col-md-4">
                                                              <label>Domicile Country</label>
                                                              <input
                                                                  className="form-control"
                                                                  type="text"

                                                              />
                                                          </div>
                                                          <div className="col-md-4">

                                                              <label>Filing Status</label>
                                                              <SBADropDown
                                                                  value={
                                                                      filingStatus
                                                                  }
                                                                  textField={"EnumName"}
                                                                  valueField={"EnumValue"}
                                                                  data={FilingStatus}
                                                              ></SBADropDown>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <label style={{ display: 'flex', alignItems: 'center' }}>
                                                                  <input className="me-1"
                                                                      type="checkbox"
                                                                  />
                                                                  <span >Invests in Managed Accounts</span>
                                                              </label>
                                                          </div>


                                                      </div>


                                                      <div className="row" style={{ marginBottom: "30px" }}>

                                                          <div className="col-md-4">
                                                              <label>Trading City</label>
                                                              <input
                                                                  className="form-control"
                                                                  type="text"
                                                              />
                                                          </div>
                                                          <div className="col-md-4">
                                                          </div>

                                                          <div className="col-md-4">
                                                              <div>
                                                                  <label style={{ display: 'flex', alignItems: 'center' }}>
                                                                      <input className="me-1"
                                                                          type="checkbox"
                                                                      />
                                                                      <span >Key Man</span>
                                                                  </label>
                                                              </div>
                                                          </div>

                                                      </div>


                                                      <div className="row" style={{ marginBottom: "20px" }}>

                                                          <div className="col-md-4" style={{ marginBottom: "20px" }}>
                                                              <label>Asset Family</label>
                                                              <input
                                                                  className="form-control"
                                                                  type="text"
                                                                  onChange={assetfamilyChange}
                                                              />
                                                          </div>
                                                          <div className="col-md-4">
                                                          </div>
                                                          <div className="col-md-4">
                                                              <label style={{ display: 'flex', alignItems: 'center' }}>
                                                                  <input className="me-1"
                                                                      type="checkbox"

                                                                  />
                                                                  <span >Allows Side Pocket</span>
                                                              </label>

                                                          </div>


                                                      </div>


                                                  </div>


                                              }</div>
                                          
                                      );
                                  case 2:
                                  case 5:
                                  case 9:
                                  case 13:
                                  case 18:
                                      return (
                                          <div className="col-md-8">
                                              {<div id="manfield" className="p-3 bg-white life-science rounded">

                                                  <div className="row">

                                                      <div className="col-md-4">

                                                          <label>Vintage Year </label>
                                                          <DatePicker value={new Date()} format="MM/dd/yyyy"></DatePicker>
                                                      </div>
                                                      <div className="col-md-4">

                                                          <label>Target Fund Raise</label>
                                                          <input
                                                              className="form-control"
                                                              type="text"
                                                          />
                                                      </div>

                                                      <div className="col-md-4">

                                                          <label>Fiscal Year End</label>
                                                          <DatePicker value={new Date()} format="MM/dd/yyyy"></DatePicker>
                                                      </div>



                                                  </div>
                                                  <div className="row" style={{ marginBottom: "20px" }}>

                                                      <div className="col-md-4">
                                                          <label>Legal Structure</label>
                                                          <SBADropDown
                                                              value={
                                                                  legalStructure
                                                              }
                                                              textField={"EnumName"}
                                                              valueField={"EnumValue"}
                                                              data={LegalStructure}
                                                              onChange={legalstructureChange}
                                                          ></SBADropDown>
                                                      </div>
                                                      <div className="col-md-4">

                                                          <label>Estimated First Close Date</label>
                                                          <DatePicker value={new Date()} format="MM/dd/yyyy"></DatePicker>
                                                      </div>
                                                      <div className="col-md-4">
                                                          <label>Audit Completion Date</label>
                                                          <DatePicker defaultValue={new Date()} format="MM/dd/yyyy" weekNumber={true} onChange={AuditCompletionDateChange} />
                                                      </div>



                                                  </div>


                                                  <div className="row" style={{ marginBottom: "20px" }}>

                                                      <div className="col-md-4">
                                                          <label>Operating Currency</label>
                                                          <SBADropDown
                                                              value={
                                                                  operatingCurreny
                                                              }
                                                              textField={"CurrencyCode"}
                                                              valueField={"CurrencyId"}
                                                              data={AttributesCurrency}
                                                              onChange={operatingcurrencyChange}
                                                          > </SBADropDown>
                                                      </div>
                                                      <div className="col-md-4">
                                                          <label>Estimated First Close Amount</label>
                                                          <input
                                                              className="form-control"
                                                              type="text"
                                                          />
                                                      </div>

                                                      <div className="col-md-4">
                                                          <label style={{ display: 'flex', alignItems: 'center' }}>
                                                              <input className="me-1"
                                                                  type="checkbox"

                                                              />
                                                              <span >Single Deal Fund</span>
                                                          </label>
                                                      </div>




                                                  </div>

                                                  <div className="row" style={{ marginBottom: "20px" }} >

                                                      <div className="col-md-4">
                                                          <label>Domicile Country</label>
                                                          <input
                                                              className="form-control"
                                                              type="text"

                                                          />
                                                      </div>
                                                      <div className="col-md-4">


                                                          <label>Estimated Second Close Date</label>
                                                          <DatePicker value={new Date()} format="MM/dd/yyyy"></DatePicker>

                                                      </div>
                                                      <div className="col-md-4">

                                                          <label style={{ display: 'flex', alignItems: 'center' }}>
                                                              <input className="me-1"
                                                                  type="checkbox"

                                                              />
                                                              <span >Continuation Fund</span>
                                                          </label>

                                                      </div>


                                                  </div>


                                                  <div className="row" style={{ marginBottom: "30px" }}>

                                                      <div className="col-md-4">
                                                          <label>Trading City</label>
                                                          <input
                                                              className="form-control"
                                                              type="text"
                                                          />
                                                      </div>
                                                      <div className="col-md-4">
                                                          <label>Estimated Second Close Amount</label>
                                                          <input
                                                              className="form-control"
                                                              type="text"
                                                          />
                                                      </div>

                                                      <div className="col-md-4">

                                                          <label style={{ display: 'flex', alignItems: 'center' }}>
                                                              <input className="me-1"
                                                                  type="checkbox"

                                                              />
                                                              <span >Offer Co Investment</span>
                                                          </label>

                                                      </div>

                                                  </div>


                                              </div>}
                                          </div>
                                      );
                                  default:
                                      return (
                                          <div className="col-md-8">
                                              {<div id="manfield" className="p-3 bg-white life-science rounded">

                                                  <div className="row">

                                                      <div className="col-md-4">

                                                          <label>Inception Date </label>
                                                          <DatePicker value={new Date()} format="MM/dd/yyyy"></DatePicker>
                                                      </div>

                                                      <div className="col-md-4">

                                                          <label>Fiscal Year End</label>
                                                          <DatePicker value={new Date()} format="MM/dd/yyyy"></DatePicker>
                                                      </div>



                                                  </div>
                                                  <div className="row" style={{ marginBottom: "20px" }}>

                                                      <div className="col-md-4">
                                                          <label>Legal Structure</label>
                                                          <SBADropDown
                                                              value={
                                                                  legalStructure
                                                              }
                                                              textField={"EnumName"}
                                                              valueField={"EnumValue"}
                                                              data={LegalStructure}
                                                              onChange={legalstructureChange}
                                                          ></SBADropDown>
                                                      </div>
                                                      <div className="col-md-4">
                                                          <label>Audit Completion Date</label>
                                                          <DatePicker defaultValue={new Date()} format="MM/dd/yyyy" weekNumber={true} onChange={AuditCompletionDateChange} />
                                                      </div>

                                                  </div>


                                                  <div className="row" style={{ marginBottom: "20px" }}>

                                                      <div className="col-md-4">
                                                          <label>Operating Currency</label>
                                                          <SBADropDown
                                                              value={
                                                                  operatingCurreny
                                                              }
                                                              textField={"CurrencyCode"}
                                                              valueField={"CurrencyId"}
                                                              data={AttributesCurrency}
                                                              onChange={operatingcurrencyChange}
                                                          > </SBADropDown>
                                                      </div>


                                                  </div>

                                                  <div className="row" style={{ marginBottom: "20px" }} >

                                                      <div className="col-md-4">
                                                          <label>Domicile Country</label>
                                                          <input
                                                              className="form-control"
                                                              type="text"

                                                          />
                                                      </div>


                                                  </div>


                                                  <div className="row" style={{ marginBottom: "30px" }}>

                                                      <div className="col-md-4">
                                                          <label>Trading City</label>
                                                          <input
                                                              className="form-control"
                                                              type="text"
                                                          />
                                                      </div>


                                                  </div>


                                                  <div className="row" style={{ marginBottom: "20px" }}>

                                                      <div className="col-md-4" style={{ marginBottom: "20px" }}>
                                                          <label>Asset Family</label>
                                                          <input
                                                              className="form-control"
                                                              type="text"
                                                              onChange={assetfamilyChange}
                                                          />
                                                      </div>


                                                  </div>


                                              </div>}
                                          </div>
                                      );
                              }
                          })()}

                      <div className="col-md-4">
                          <div id="manfield" className="p-3 bg-white life-science rounded">

                              <div className="row" style={{ marginBottom: "20px" }}>
                                  <div className="col-md-6">
                                      
                                          <label>Letters to Investor Frequency</label>
                                          <SBADropDown
                                              value={
                                                  letterstoinvestorFrequency
                                              }
                                              textField={"EnumName"}
                                              valueField={"EnumValue"}
                                              data={InvestorLetterfrequency}
                                          ></SBADropDown>
                                     
                                  </div>



                                  <div className="col-md-6">
                                      <label>Asset Type</label>
                                      <SBADropDown
                                          value={
                                              assetsecurityType
                                          }
                                          textField={"EnumName"}
                                          valueField={"EnumValue"}
                                          data={SecurityType}
                                          onChange={assetsecurityTypeChange}
                                      ></SBADropDown>
                                  </div>

                              </div>


                              <div className="row" style={{ marginBottom: "20px" }}>

                                  <div className="col-md-6">
                                      <label style={{ display: 'flex', alignItems: 'center' }}>
                                          <input className="me-1"
                                              type="checkbox"

                                              onChange={() => {
                                                  setquartelyLetter(value => !value)
                                              }}
                                          />
                                          <span >Quarterly Letter</span>
                                      </label>
                                  </div>

                                  <div className="col-md-6">
                                      <label style={{ display: 'flex', alignItems: 'center' }}>
                                          <input className="me-1"
                                              type="checkbox"

                                              onChange={() => {
                                                  setassetfactSheet(value => !value)
                                              }}
                                          />
                                          <span >Asset Fact Sheet</span>
                                      </label>
                                  </div>

                              </div>

                              <div className="row" style={{ marginBottom: "20px" }}>
                                  <div className="col-md-6">

                                      <label>Reporting Frequency</label>
                                      <SBADropDown
                                          value={
                                              reportingFrequency
                                          }
                                          textField={"EnumName"}
                                          valueField={"EnumValue"}
                                          data={Reportingfrequency}
                                      ></SBADropDown>
                                  </div>
                                  <div className="col-md-6">
                                      <label style={{ display: 'flex', alignItems: 'center' }}>
                                          <input className="me-1"
                                              type="checkbox"

                                              onChange={() => { setinvestmentPack(value => !value) }}
                                          />
                                          <span >Investment Pack</span>
                                      </label>
                                  </div>

                              </div>

                              <div className="row" style={{ marginBottom: "20px" }}>
                                  <div className="col-md-6">

                                      <label>Performance Estimate Frequency</label>
                                      <SBADropDown
                                          value={
                                              performanceestimateFrequency
                                          }
                                          textField={"EnumName"}
                                          valueField={"EnumValue"}
                                          data={PerformanceEstimatefrequency}
                                      ></SBADropDown>
                                  </div>

                                  <div className="col-md-6">

                                      <label>Investment Type</label>
                                      <SBADropDown
                                          value={
                                              investmentType
                                          }
                                          textField={"EnumName"}
                                          valueField={"EnumValue"}
                                          data={InvestmentType}
                                          onChange={InvestmentTypeChange}
                                      ></SBADropDown>
                                  </div>

                              </div>

                              <div className="row" style={{ marginBottom: "20px" }}>

                                  <div className="col-md-6">

                                      <label>Exposure Report Frequency</label>
                                      <SBADropDown
                                          value={
                                              exposurereportFrequency
                                          }
                                          textField={"EnumName"}
                                          valueField={"EnumValue"}
                                          data={ExposureReportingfrequency}
                                      ></SBADropDown>
                                  </div>
                              </div>

                              <div className="row" style={{ marginBottom: "20px" }}>
                                  <div className="col-md-6">
                                      <label>Personal Capital</label>
                                      <input
                                          className="form-control"
                                          type="text"

                                      />
                                  </div>
                              </div>
                          </div>
                      </div>

                  </div>
                     
                  </div>
              <div className="col-lg-12 d-flex gap-12 justify-content-lg-end p-0 align-items-center" style={{ marginTop: "80px" }}>
                  <button className="s-sm-btn mx-1" onClick={CanceltoDetails}> Cancel</button>
                  <button className='p-sm-btn mx-1' onClick={SaveAttributeDetails} disabled={!isEditable}>Save</button>

              </div>
              </div>
        
             

          </div>

          
                         
    
                           

  );
};
